<template>
  <div>
    <h1 class="text-pagename">Set zone on app</h1>
    <v-layout row>
      <!-- <v-flex xs4></v-flex>
      <v-flex xs4>
        <v-spacer></v-spacer>
      </v-flex> -->
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :search="search"
      :loading="loading_message"
      :items="transfer_zone_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.transport_zone_id }}</td>
        <td class="text-xs-center">{{ props.item.transport_zone_name_th }}</td>
        <td class="text-xs-center" style="position:relative;">
          <v-switch
            v-model="aaaa[props.index]"
            @change="popularType(aaaa[props.index])"
            v-if="bbbb == false"
            color="primary"
            class="popular_toggle"
          ></v-switch>
          <v-switch
            :disabled="aaaa[props.index] == true ? false : true"
            v-model="aaaa[props.index]"
            @change="popularType(aaaa[props.index])"
            v-if="bbbb == true"
            color="primary"
            class="popular_toggle"
          ></v-switch>
        </td>
      </template>

      <template slot="no-data">
        <div class="text-xs-center" v-if="loading_message== false">No data available ..</div>
        <div class="text-xs-center" v-else>
          <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>Loading data ...
        </div>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    search: "",
    loading_message: false,
    aaaa: [],
    bbbb: false,
    pagination: { rowsPerPage: 10 },
    headers: [
      {
        text: "ID",
        align: "center",
        sortable: false,
        value: "id"
      },
      {
        text: "Zone Name",
        align: "center",
        value: "transport_zone_name_th",
        sortable: false
      },
      {
        text: "Popular",
        align: "center",
        value: "popular",
        sortable: false
      }
    ]
  }),
  computed: {
    ...mapState({
      transfer_zone_list: state => state.fetchFoodZoneBack.transfer_zone_list
    }),
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  async created() {
    this.loading_message = true;
    await this.$store.dispatch("fetchFoodZoneBack/getTransferZoneList");
    this.loading_message = false;
  },

  methods: {
    popularType(item) {}
  }
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 45%;
}
</style>
 
